import { render } from "./ConstructorTab.vue?vue&type=template&id=d61e24ea&scoped=true"
import script from "./ConstructorTab.vue?vue&type=script&lang=js"
export * from "./ConstructorTab.vue?vue&type=script&lang=js"

import "./ConstructorTab.vue?vue&type=style&index=0&id=d61e24ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d61e24ea"]])

export default __exports__